import { getRelativeTimeByMS, NowTime } from '../utils/NowTime';
import { map, tap } from 'rxjs';
export function addStartTime() {
    return map((config) => {
        config.metadata = { startTime: getRelativeTimeByMS() };
        return config;
    });
}
export function addEndTime() {
    return map((res) => {
        res.config.metadata.endTime = getRelativeTimeByMS();
        return res;
    });
}
export function parseServerTime() {
    return tap((res) => {
        NowTime.parse(res.config.metadata, Number(res.headers.timestamp), res.config);
    });
}
//# sourceMappingURL=ServerTime.js.map